import styled from 'styled-components';
import {paddingCss} from '../../styles/box.styled';

export const FeatureBodyStyled = styled.div`
  ${paddingCss};
`;

